import { Typography } from "@material-tailwind/react";
import Pagination from "components/wps/Pagination";
import { get } from "lodash";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import ApiService from "utills/ApiService";

const Participants = (props: any) => {
  const { ticketTab, translate, isMobile, token, eventID, applyDate, filter, ticketPlatform, attendantPage, setAttendantPaging, attendantPaging, language, setAttendantPage } = props;
  const [attendantInfo, setAttendantInfo] = useState([] as any);

  useEffect(() => {
    if (token !== '' && eventID !== '') {
      fetchAttendantInfo();
    }
  }, [attendantPage, eventID, applyDate, filter, token]);

  const fetchAttendantInfo = async () => {
    try {
      const result = await ApiService.get(`dashboards/orders/${eventID}/participants/summary/page/${attendantPage}?limit=10&from_date=${applyDate.start}&to_date=${applyDate.end}&ticket_platform=${ticketPlatform}`, token);

      if (result && result.data && result.data.length > 0) {
        setAttendantPaging(result.paging);
        setAttendantInfo(result.data);
      } else {
        setAttendantInfo([]);
        setAttendantPaging(null);
      }

    } catch (error: any) {
      toast.error(error.message);
    }
  }

  if (ticketTab === 0) {
    return (
      <div className={`w-full ${!isMobile && 'bg-white mt-[16px]'} ${isMobile && attendantInfo?.length === 0 && 'mt-[16px]'}`}>
        <div className={`w-full h-[64px] flex items-center border-b border-[#e9ecff] px-[16px] ${isMobile && 'bg-white'}`}>
          <div className="text-16 font-600 uppercase">{translate('attendees-information')}</div>
        </div>

        <div className={`w-full ${!isMobile ? 'p-[16px]' : 'px-[16px] pt-[16px]'}`}>

          {
            (attendantInfo.length > 0) &&
            <div className={`w-full ${!isMobile ? 'mt-[16px]' : ''}`}>
              {
                !isMobile ?
                  <table className="w-full min-w-max table-auto text-left">
                    <thead className="bg-[#e9ecff]">
                      <tr>
                        <th className="p-4">
                          <Typography
                            variant="small"
                            className="text-14 !font-500"
                            placeholder="Typography"
                            onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                            onResizeCapture={() => { }}
                          >
                            {translate('no')}
                          </Typography>
                        </th>

                        <th className="p-4">
                          <Typography
                            variant="small"
                            className="text-14 !font-500"
                            placeholder="Typography"
                            onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                            onResizeCapture={() => { }}
                          >
                            {translate('category-event')}
                          </Typography>
                        </th>

                        <th className="p-4">
                          <Typography
                            variant="small"
                            className="text-14 !font-500"
                            placeholder="Typography"
                            onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                            onResizeCapture={() => { }}
                          >
                            {translate('quantity')}
                          </Typography>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        attendantInfo.length > 0 &&
                        attendantInfo.map((item: any, index: number) => {
                          const isLast = index === attendantInfo.length - 1;
                          const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

                          return (
                            <tr key={`event_${item.code}_${index}`} className="table-row">
                              <td className={classes}>
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="text-14"
                                  placeholder="Typography"
                                  onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                                  onResizeCapture={() => { }}
                                >
                                  {(index < 9) && attendantPaging.current_page - 1}{index + 1}
                                </Typography>
                              </td>

                              <td className={classes}>
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="text-14"
                                  placeholder="Typography"
                                  onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                                  onResizeCapture={() => { }}
                                >
                                  {get(item, `category_name_${language}`, '')}
                                </Typography>
                              </td>

                              <td className={classes}>
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="text-14"
                                  placeholder="Typography"
                                  onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                                  onResizeCapture={() => { }}
                                >
                                  {item.quantity}
                                </Typography>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                  :
                  <div className="grid grid-cols-1 gap-[16px]">
                    {
                      attendantInfo.map((item: any, index: number) => {
                        return (
                          <div className="w-full rounded-[8px] bg-white p-[16px] grid grid-cols-1 gap-[12px]" key={`participant_item_${index}`}>
                            <div className="w-full flex items-start justify-between text-14 gap-[8px]">
                              <div className="font-500 w-[100px]">{translate('no')}</div>
                              <div className="flex-1">{(index < 9) && attendantPaging.current_page - 1}{index + 1}</div>
                            </div>
                            <div className="w-full flex items-start justify-between text-14 gap-[8px]">
                              <div className="font-500 w-[100px]">{translate('category-event')}</div>
                              <div className="flex-1">{get(item, `category_name_${language}`, '')}</div>
                            </div>
                            <div className="w-full flex items-start justify-between text-14 gap-[8px]">
                              <div className="font-500 w-[100px]">{translate('quantity')}</div>
                              <div className="flex-1">{item.quantity}</div>
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
              }


              {
                attendantPaging &&
                <div className={`board__bottom ${isMobile ? 'mt-[16px]' : 'pagination-desktop'}`}>
                  {
                    attendantPaging.total_page > 1 &&
                    <Pagination
                      setPage={setAttendantPage}
                      paging={attendantPaging}
                    />
                  }
                </div>
              }
            </div>
          }

        </div>
      </div>
    )
  } else {
    return <></>
  }
};

export default Participants;